"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolygonAdjust = void 0;
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const util_1 = require("./util");
const GeometryFactory_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/GeometryFactory.js"));
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
class PolygonAdjust {
    constructor() {
        this._geometryFactory = new GeometryFactory_js_1.default();
    }
    adjust(polygons, geometryParser) {
        let adjustedPolygons = new Array();
        for (let polygon of polygons) {
            let polygonSegs_shell = new Array();
            const shell = polygon.getExteriorRing();
            let points_shell = shell.getCoordinates();
            for (let i = 0; i < points_shell.length - 1; i++) {
                polygonSegs_shell.push(new LineSegment_js_1.default(points_shell[i], points_shell[i + 1]));
            }
            let door_polygonSeg_map = new Map(); //用于记录判断门是否属于该多边形时的边，在调整门空间的时候排除掉该边，避免原地调整
            let doors_belongHere = this.computeDoorsBelongThisRoom(polygonSegs_shell, geometryParser, door_polygonSeg_map); //TODO：计算门归属的时候没有考虑内环,有可能会有点问题
            if (!doors_belongHere) {
                adjustedPolygons.push(polygon);
            }
            else {
                let resultPolygon = this.singleAdjust(polygon, polygonSegs_shell, doors_belongHere, door_polygonSeg_map);
                adjustedPolygons.push(resultPolygon);
            }
        }
        return adjustedPolygons;
    }
    singleAdjust(polygon, polygonSegs, doors, door_polygonSeg_map) {
        let wallAngles = new Array();
        let walls = new Array();
        const shell = polygon.getExteriorRing();
        const holes = new Array();
        for (let i = 0; i < polygon.getNumInteriorRing(); i++) {
            const hole = polygon.getInteriorRingN(i);
            holes.push(hole);
        }
        let resultPolygon = this._geometryFactory.createPolygon(shell, holes);
        for (let seg of polygonSegs) {
            let isDoor = false;
            for (let door of doors) {
                if (util_1.Util.isTwoSegmentsEquals(seg, door)) {
                    isDoor = true;
                    break;
                }
            }
            if (!isDoor) {
                walls.push(seg);
                wallAngles.push(util_1.Util.computeAngle(seg.p0, seg.p1));
            }
        }
        for (let door of doors) {
            let angle = util_1.Util.computeAngle(door.p0, door.p1);
            let nearestWall_p0;
            let nearestWall_p1;
            let minDis_p0 = Number.POSITIVE_INFINITY;
            let minDis_p1 = Number.POSITIVE_INFINITY;
            for (let i = 0; i < wallAngles.length; i++) {
                let dAngle = Math.abs(angle - wallAngles[i]);
                if (dAngle < 1 || dAngle > 179) { //判断平行的角度容差
                    let seg = walls[i];
                    if (seg == door_polygonSeg_map.get(door)) {
                        continue;
                    }
                    let dis_p0 = seg.distance(door.p0);
                    if (dis_p0 < 241) { //一般的墙宽度为200或240，这里容差设置个241
                        if (dis_p0 < minDis_p0) {
                            minDis_p0 = dis_p0;
                            nearestWall_p0 = seg;
                        }
                    }
                    let dis_p1 = seg.distance(door.p1);
                    if (dis_p1 < 241) {
                        if (dis_p1 < minDis_p1) {
                            minDis_p1 = dis_p1;
                            nearestWall_p1 = seg;
                        }
                    }
                }
            }
            //如果没有符合条件的墙，则不调整了，一般是被当成门的大窗户之类的
            if (nearestWall_p0 == undefined && nearestWall_p1 == undefined) {
                //console.error("墙体调整失败");
                continue;
            }
            let adjust_p0;
            let adjust_p1;
            if (nearestWall_p0 && nearestWall_p1) { //两个端点都能找到邻近墙的情况
                if (nearestWall_p0.p0.equals2D(door.p0, 1e-3) || nearestWall_p0.p1.equals2D(door.p0, 1e-3) || nearestWall_p1.p0.equals2D(door.p1, 1e-3) || nearestWall_p1.p1.equals2D(door.p1, 1e-3)) { //这也是大窗户的情况
                    continue;
                }
                if (nearestWall_p0.p0.distance(door.p0) < nearestWall_p0.p1.distance(door.p0)) {
                    adjust_p0 = new Coordinate_js_1.default(nearestWall_p0.p0);
                }
                else {
                    adjust_p0 = new Coordinate_js_1.default(nearestWall_p0.p1);
                }
                if (nearestWall_p1.p0.distance(door.p1) < nearestWall_p1.p1.distance(door.p1)) {
                    adjust_p1 = new Coordinate_js_1.default(nearestWall_p1.p0);
                }
                else {
                    adjust_p1 = new Coordinate_js_1.default(nearestWall_p1.p1);
                }
                let polygonPoints = resultPolygon.getExteriorRing().getCoordinates();
                let newPolygonPoints = this.adjustPolygonPoints(new LineSegment_js_1.default(adjust_p0, adjust_p1), polygonPoints);
                if (newPolygonPoints.length < 4) {
                    //补全被移除的首尾重复点
                    polygonPoints.push(polygonPoints[0]);
                    continue;
                }
                resultPolygon = this._geometryFactory.createPolygon(this._geometryFactory.createLinearRing(newPolygonPoints), holes);
            }
            else { //只有一个端点能找到的情况
                //将门进行平行调整
                if (nearestWall_p0) {
                    if (nearestWall_p0.p0.distance(door.p0) < nearestWall_p0.p1.distance(door.p0)) {
                        adjust_p0 = new Coordinate_js_1.default(nearestWall_p0.p0);
                    }
                    else {
                        adjust_p0 = new Coordinate_js_1.default(nearestWall_p0.p1);
                    }
                    let vec_p0p1 = new Vector2D_js_1.default(door.p0, door.p1);
                    adjust_p1 = new Coordinate_js_1.default(adjust_p0.x + vec_p0p1.getX(), adjust_p0.y + vec_p0p1.getY());
                }
                else {
                    if (nearestWall_p1.p0.distance(door.p1) < nearestWall_p1.p1.distance(door.p1)) {
                        adjust_p1 = new Coordinate_js_1.default(nearestWall_p1.p0);
                    }
                    else {
                        adjust_p1 = new Coordinate_js_1.default(nearestWall_p1.p1);
                    }
                    let vec_p1p0 = new Vector2D_js_1.default(door.p1, door.p0);
                    adjust_p0 = new Coordinate_js_1.default(adjust_p1.x + vec_p1p0.getX(), adjust_p1.y + vec_p1p0.getY());
                }
                let polygonPoints = resultPolygon.getExteriorRing().getCoordinates();
                let isIntersects = false;
                let adjustedDoor = new LineSegment_js_1.default(adjust_p0, adjust_p1);
                let insertPoint = nearestWall_p0 ? adjust_p1 : adjust_p0;
                for (let i = 0; i < polygonPoints.length - 1; i++) {
                    isIntersects = new LineSegment_js_1.default(polygonPoints[i], polygonPoints[i + 1]).distance(insertPoint) < 1e-3;
                    if (isIntersects) {
                        polygonPoints.splice(i + 1, 0, insertPoint);
                        break;
                    }
                }
                if (!isIntersects) { //没有交点则跳过
                    continue;
                }
                let newPolygonPoints = this.adjustPolygonPoints(adjustedDoor, polygonPoints);
                resultPolygon = this._geometryFactory.createPolygon(this._geometryFactory.createLinearRing(newPolygonPoints), holes);
            }
        }
        return resultPolygon;
    }
    adjustPolygonPoints(adjustedDoor, polygonPoints) {
        let index_p0 = this.findPointFromPolygonPoints(adjustedDoor.p0, polygonPoints);
        let index_p1 = this.findPointFromPolygonPoints(adjustedDoor.p1, polygonPoints);
        if (index_p0 < 0 || index_p1 < 0) {
            //console.error("门调整失败");
            return polygonPoints;
        }
        //先移除首尾重复点
        polygonPoints.splice(polygonPoints.length - 1, 1);
        //计算往哪边走距离更远
        let distance_p0_to_p1 = 0;
        for (let i = index_p0;; i++) {
            let index = (i + polygonPoints.length) % polygonPoints.length;
            let nextIndex = (i + 1 + polygonPoints.length) % polygonPoints.length;
            if (index == index_p1)
                break;
            distance_p0_to_p1 += (polygonPoints[index].distance(polygonPoints[nextIndex]));
        }
        let distance_p1_to_p0 = 0;
        for (let i = index_p1;; i++) {
            let index = (i + polygonPoints.length) % polygonPoints.length;
            let nextIndex = (i + 1 + polygonPoints.length) % polygonPoints.length;
            if (index == index_p0)
                break;
            distance_p1_to_p0 += (polygonPoints[index].distance(polygonPoints[nextIndex]));
        }
        let newPoints = new Array();
        //保留长的那段
        if (distance_p0_to_p1 > distance_p1_to_p0) {
            for (let i = index_p0;; i++) {
                let index = (i + polygonPoints.length) % polygonPoints.length;
                newPoints.push(polygonPoints[index]);
                if (index == index_p1)
                    break;
            }
        }
        else {
            for (let i = index_p1;; i++) {
                let index = (i + polygonPoints.length) % polygonPoints.length;
                newPoints.push(polygonPoints[index]);
                if (index == index_p0)
                    break;
            }
        }
        //加入首尾重复点
        newPoints.push(newPoints[0]);
        return newPoints;
    }
    findPointFromPolygonPoints(point, polygonPoints) {
        for (let i = 0; i < polygonPoints.length; i++) {
            if (point.equals2D(polygonPoints[i])) {
                return i;
            }
        }
        return -1;
    }
    computeDoorsBelongThisRoom(polygonSegs, geometryParser, door_polygonSeg_map) {
        let doors_belongHere = new Array();
        let doors = geometryParser.getDoorLineSegments();
        for (let door of doors) {
            for (let seg of polygonSegs) {
                if (seg.distance(door) < 0.1) { //判断距离
                    let dAngle = Math.abs(util_1.Util.computeAngle(seg.p0, seg.p1) - util_1.Util.computeAngle(door.p0, door.p1));
                    if (dAngle < 1 || dAngle > 179) { //判断是否平行
                        door_polygonSeg_map.set(door, seg);
                        doors_belongHere.push(door);
                        break;
                    }
                }
            }
        }
        if (doors_belongHere.length === 0) {
            console.error("该房间没有门");
            return null;
        }
        return doors_belongHere;
    }
}
exports.PolygonAdjust = PolygonAdjust;
